import { BaseComponent } from '../../base-component';
import { sendCustomError } from '@otto-ec/global-resources/apm';

export type Fragment = {
    openLayer: string;
    energyEfficiencyComponent: string;
};

export class EnergyEfficiencyBaseComponentComponent extends BaseComponent {
    public rootSelector = '.js_pdp_eek';

    public async onHtmlLoaded(): Promise<void> {
        if (this.isPresent()) {
            this.initEnergyEfficiencyComponent();
        }
    }

    private initEnergyEfficiencyComponent(): void {
        this.reactToHashInURL();
    }

    private reactToHashInURL() {
        const fragment = o_util.fragment.deserialize<Fragment>(false);
        if (fragment.openLayer !== 'energyEfficiencyImageLayer') {
            return;
        }
        const componentId = fragment.energyEfficiencyComponent;
        this.removeLayerInfoFromHash(fragment);
        if (componentId) {
            this.openSheetByComponentId(componentId);
        } else if (this.hasExactlyOneLabel()) {
            this.openSheetIfNoComponentSpecified();
        }
    }

    private removeLayerInfoFromHash(fragment: Fragment): void {
        const newFragment: Record<string, string> = { ...fragment };
        delete newFragment.openLayer;
        delete newFragment.energyEfficiencyComponent;
        window.location.hash = o_util.fragment.serialize(newFragment) || '';
    }

    private openSheetByComponentId(componentId: string) {
        const sheetContentElement = document.querySelector(
            `${this.rootSelector} .js_openInPaliSheet[data-sheet-id='${componentId}']`
        ) as HTMLElement;
        if (sheetContentElement) {
            this.openSheet(sheetContentElement);
        } else {
            sendCustomError('ft5.dcs', new Error(`unable to find energy efficiency layer for ${componentId}`), {
                messageType: 'slug',
            });
        }
    }

    private openSheetIfNoComponentSpecified() {
        const layerContentElement = document.querySelector(`${this.rootSelector} .js_openInPaliSheet`) as HTMLElement;
        if (layerContentElement) {
            this.openSheet(layerContentElement);
        }
    }

    private openSheet(sheetContentElement: HTMLElement): void {
        if (sheetContentElement) {
            const sheet = new o_global.pali.sheetBuilder({
                title: sheetContentElement.dataset.sheetTitle,
                menuContent: sheetContentElement.dataset.sheetMenuContent,
                content: sheetContentElement.dataset.sheetContent,
                lockMobileHeight: false,
            });
            sheet.open();
        }
    }

    private hasExactlyOneLabel() {
        const moduleElement = this.getRootElement();
        const innerHTML = moduleElement.innerHTML;
        const numberOfLabels = (innerHTML.match(/pdp_eek__label /g) || []).length;
        return numberOfLabels === 1;
    }
}
